'use client'

import {
  Badge,
  Card,
  Col,
  Icon,
  type IconNames,
  Row,
  Typography,
} from '@repo/ui/components'
import { type MessagesKeys, useTranslate } from '@repo/shared/hooks'
import { Link, usePathname } from '@repo/shared/i18n/navigation'

type MenuItem = {
  label: MessagesKeys
  icon: IconNames
  activeIcon?: IconNames
  badge?: {
    text: MessagesKeys
    variant: 'liquid' | 'solid'
    count?: number
  }
  href: string
  disabled?: boolean
}

export const WalletWithdrawSidebarLayout = () => {
  const menuItems: MenuItem[] = [
    {
      label: 'walletWithdrawLayout_onlinePayment',
      icon: 'UndefinedGhostLine',
      href: '/wallet/withdraw/online-payment',
      disabled: false,
    },
  ]

  const { t } = useTranslate()
  const pathname = usePathname()

  return (
    <Col className='gap-md'>
      <Card>
        <Col className='gap-md'>
          {menuItems.map((item, index) => {
            const isActive = pathname?.includes(item.href)
            return (
              <Row
                key={index}
                as={Link}
                href={item.href}
                className={
                  item.disabled
                    ? 'opacity-50 cursor-not-allowed pointer-events-none'
                    : ''
                }
              >
                <Row className='py-2xs gap-md'>
                  <Icon
                    name={item.icon}
                    size='sm'
                    color={
                      item.disabled
                        ? 'fill-neutral-surface-40'
                        : 'fill-neutral-surface-100'
                    }
                  />
                  <Typography
                    size='sm'
                    weight='bold'
                    color={
                      item.disabled ? 'text-neutral-surface-40' : undefined
                    }
                  >
                    {t(item.label)}
                  </Typography>
                </Row>
                {item.badge && (
                  <Badge size='sm' variant={item.badge.variant} color='neutral'>
                    {item.badge.count && `${item.badge.count} `}
                    {t(item.badge.text)}
                  </Badge>
                )}
                {isActive && (
                  <Icon
                    name='ChevronLeftLine'
                    size='sm'
                    color='fill-neutral-surface-20'
                  />
                )}
              </Row>
            )
          })}
        </Col>
      </Card>
    </Col>
  )
}
